import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {useMemo, useState} from "../../../__snowpack__/pkg/react.js";
export const useCategoryAttributes = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (param) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/shop/get-categoryAttributes-by-channel`, param);
      setData(data2);
      return data2;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const mandatoryData = useMemo(() => {
    return data.filter((_) => _.mandatory);
  }, [data]);
  const optionalData = useMemo(() => {
    return data.filter((_) => !_.mandatory);
  }, [data]);
  const resetAttributes = () => {
    setData([]);
  };
  return {
    resetAttributes,
    categoryAttributeLoading: loading,
    categoryAttributes: data,
    mandatoryCategoryAttributes: mandatoryData,
    optionalCategoryAttributes: optionalData,
    fetchCategoryAttributes: fetchData
  };
};
export const useCategoryAttributesModel = createModel(useCategoryAttributes);
